module.exports = {
  OFF: 'off',
  STARTING: 'starting',
  RUNNING: 'running',
  START_AND_STOP: 'start-and-stop',
};
